import React from 'react';

import { MOTActionTile } from './ActionTiles/MOTActionTile';
import { ReferActionTile } from './ActionTiles/ReferActionTile';
import { TrackActionTile } from './ActionTiles/TrackActionTile';

import styles from './MoreFromMotorway.module.scss';

export type TileProps = {
  mentionMeSituation?: string;
  onClick?: () => void;
};

export type ActionKey = 'refer' | 'track' | 'motTax';

type ConfigEntry = TileProps & { enabled: boolean; key: ActionKey };

export type MoreFromMotorwayProps = Prettify<{
  config?: ConfigEntry[];
}>;

const componentMap: Record<ActionKey, React.ComponentType<TileProps>> = {
  motTax: MOTActionTile,
  refer: ReferActionTile,
  track: TrackActionTile,
};

const defaultConfig: MoreFromMotorwayProps['config'] = [
  { enabled: true, key: 'refer' },
  { enabled: true, key: 'track' },
  { enabled: false, key: 'motTax' },
];

export const MoreFromMotorway = ({ config = defaultConfig }: MoreFromMotorwayProps) => (
  <div className={styles.moreFromMotorway} data-testid="more-from-motorway">
    {config
      .filter(({ enabled }) => enabled)
      .map(({ key, mentionMeSituation, onClick }) => {
        const Component = componentMap[key];
        return <Component key={key} mentionMeSituation={mentionMeSituation} onClick={onClick} />;
      })}
  </div>
);
